export const getBackgroundColor = (color) => {
    return color ? color : window.getComputedStyle(document.body).getPropertyValue('background-color');
};

const prepareRGB = backgroundColor => backgroundColor.slice(4, -1).split(',').map(x => +x);

function hexToRGB(hex) {
    const m = hex.match(/^#?([\da-f]{2})([\da-f]{2})([\da-f]{2})$/i);
    return [
        parseInt(m[1], 16),
        parseInt(m[2], 16),
        parseInt(m[3], 16),
    ];
}

export function reverseColor(background) {
    const [r, g, b] = background.includes('rgb') ? prepareRGB(background) : hexToRGB(background);

    let color;
    const luminance = (r * 0.299 + g * 0.587 + b * 0.114) / 256;
    if (luminance <= 0.50) {
        color = '#fcfcfc';
    } else {
        color = '#444444';
    }
    return color;
}

export const getMaterialImageAlt = (material, picture) => {
    return picture ? `${material.number || material.inventory_number} - ${picture.alt_uuid}` :
        'Image placeholder for missing image';
};

export const isFeatureFlagEnabled = (profile, flagName) => profile && profile.feature_flags.find(ff => ff.name === flagName);


// WEBPACK FOOTER //
// ./src/common/Utils.js